export default "__VITE_ASSET__d1OA1sr6__"